<template>
  <div
    class="details-container"
    v-loading="detailsLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <ak-header :pageType="'detailsContainer'" @homeSecurity="fanhui"></ak-header>
    <div>
      <details-left
                    :info="vehicleInfo"
                    :taiYaData="taiYaData"
                    :veRealAlarmData="vehehRealAlarmData"
                    :tagStatusData="tagStatusData"
                    :heartListData="heartListData"
                    :vehRealTimeData="vehRealTimeData"
                    ></details-left>
      <details-center @setCar="setCar"
                      @rangeChange="getPathData"
                      :vin="vin"
                      :path="path"
                      :doorData="doorData"
                      :humidityData="humidityData"
                      :protocalType="protocalType"
                      :protocalData="protocalData"
                      ></details-center>
      <details-right
        :vin="vin"
        :static="rightBar"
        :callPoliceInfo="policeInfoData"
        :videoUrl ="videoUrl"
        :videoUrl2 ="videoUrl2"
        :chargeRecord="chargeRecord"
        :obdRecord="obdRecord"
        :runKmRecord="runKmRecord"
        :vehicleInfo="vehicleInfo"
        :protocalType="protocalType"
      ></details-right>
    </div>
  </div>
</template>

<script>
import api from '../api'
import dayjs from 'dayjs'

import detailsLeft from './detailsLeft'
import detailsCenter from './detailsCenter'
import detailsRight from './detailsRight'
import akHeader from '@/component/header'

export default {
  name: 'detailsContainer',
  components: { detailsLeft, detailsCenter, detailsRight, akHeader },
  data () {
    return {
      detailsLoading: false,
      trackData: [],

      vehicleInfo: {},
      taiYaData: {},
      rightBar: {},
      videoUrl: '',
      videoUrl2: '',
      chargeRecord: [],
      runKmRecord: [],
      obdRecord: [],
      path: [],

      vin: '',
      vinIng: '',
      humidityData: [],
      doorData: [],
      vehRealTimeData: {},
      heartListData: [],
      policeInfoData: [],
      timer: null,
      vehRealTimeDataTimer: null,
      vehRealTimeDataduration: 3000,
      duration: 10000,
      protocalType: 5,
      // 燃油车 当日行驶情况统计 当日油量变化
      protocalData: {},
      monthCatalystDischargeStatis: {},
      vehehRealAlarmData: {},
      // 标签状态
      tagStatusData: {},
      isLoadingTrackData: false,
      globalSta: dayjs(new Date()).format('YYYY-MM-DD 00:00:00'),
      globalEnd: dayjs(new Date()).format('YYYY-MM-DD 23:59:59'),
      trackTimer: null,
      durationTimer: null,
      durationSixty: 60000,
      taiYaDataTimer: null,
      taiYaDataDuration: 30000,
      trackDuration: 60000,
      durationmidityTimer: null,
      vehehRealAlarmTimer: null,
      vehehRealAlarmduration: 10000,
      durationmiditySixty: 60000,
      HeardurationTimer: null,
      Heardurationduration: 10000,
      PoliceInfoTimer: null,
      PoliceInfoduration: 10000,
      tagStatusTimer: null,
      tagStatusduration: 10000,
      GPS: {
        PI: 3.14159265358979324,
        x_pi: 3.14159265358979324 * 3000.0 / 180.0,
        delta: function (lat, lon) {
          // Krasovsky 1940
          //
          // a = 6378245.0, 1/f = 298.3
          // b = a * (1 - f)
          // ee = (a^2 - b^2) / a^2;
          var a = 6378245.0 //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
          var ee = 0.00669342162296594323 //  ee: 椭球的偏心率。
          var dLat = this.transformLat(lon - 105.0, lat - 35.0)
          var dLon = this.transformLon(lon - 105.0, lat - 35.0)
          var radLat = lat / 180.0 * this.PI
          var magic = Math.sin(radLat)
          magic = 1 - ee * magic * magic
          var sqrtMagic = Math.sqrt(magic)
          dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI)
          dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI)
          return { 'lat': dLat, 'lon': dLon }
        },

        // GPS---高德
        gcj_encrypt: function (wgsLat, wgsLon) {
          if (this.outOfChina(wgsLat, wgsLon)) {
            return { 'lat': wgsLat, 'lon': wgsLon }
          }

          var d = this.delta(wgsLat, wgsLon)
          return { 'lat': wgsLat - 0 + d.lat, 'lng': wgsLon - 0 + d.lon }
        },
        outOfChina: function (lat, lon) {
          if (lon - 72.004 < 0 || lon - 137.8347 > 0) {
            return true
          }
          if (lat - 0.8293 < 0 || lat - 55.8271 > 0) {
            return true
          }
          return false
        },
        transformLat: function (x, y) {
          var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0
          ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0
          ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0
          return ret
        },
        transformLon: function (x, y) {
          var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
          ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0
          ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0
          ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0
          return ret
        }
      }
    }
  },
  mounted () {
    // TODOS
    this.vin = this.$route.query.vid
    this.vinIng = this.$route.query.vinIng
    this.protocalType = Number(this.$route.query.protocalType)
  },
  destroyed () {
    this.clearIntervalAll()
  },
  methods: {
    fanhui (type) {
      this.homeLoading = true
      setTimeout(() => {
        this.homeLoading = false
        if (type === 'homeContainer') {
          this.$router.push({ path: '/homeSecurity' })
        } else {
          this.$router.push({ path: '/homeContent' })
        }
      }, 600)
    },
    setStaticData () {
      const self = this
      const vin = this.vin
      const now = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
      const lastDay = dayjs(new Date() - 60 * 60 * 24 * 1000).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      // if (this.protocalType === 6) {
      api.getFuelDedailChartData(this.vin).then((res) => {
        if (res.data.meta.code === 200) {
          self.protocalData = res.data.data
        }
      })
      // }
      const getStaticeData = async function () {
        // 车辆基本信息
        api.getVehicleInfo({ vid: vin }).then(function (res) {
          if (res.data.meta.code === 200) {
            self.vehicleInfo = res.data.data
            let imei = res.data.data.imei
            api.getVideoUrl({ channelId: 1, imei: imei, videoType: 4, streamType: 1 }).then(function (res) {
              if (res.data.meta.code === 200) {
                self.videoUrl = res.data.data
              }
            })
            api.getVideoUrl({ channelId: 3, imei: imei, videoType: 4, streamType: 1 }).then(function (res) {
              if (res.data.meta.code === 200) {
                self.videoUrl2 = res.data.data
              }
            })
          }
        })

        const chargeMonthSt = await api.getChargeMonthSt({ vid: vin })
        const runKmMonthSt = await api.getRunKmMonthSt({ vid: vin })

        if (self.protocalType === 5) {
          api
            .getChargeRecord({
              vid: vin,
              startTime: lastDay,
              endTime: now
            })
            .then(function (res) {
              if (res.data.meta.code === 200) {
                self.chargeRecord = res.data.data
              }
            })
        } else {
          api
            .getObdFaultOrOilStatis({
              vid: vin,
              beginTime: lastDay,
              endTime: now,
              start: 0,
              limit: 9999
            })
            .then(function (res) {
              if (res.data.meta.code === 200) {
                self.obdRecord = res.data.rows
              }
            })
        }

        api.getRunKmRecord({
          vid: vin,
          startTime: lastDay,
          endTime: now
        })
          .then(function (res) {
            if (res.data.meta.code === 200) {
              self.runKmRecord = res.data.data
            }
          })

        let sta = self.globalSta
        let end = self.globalEnd
        const trackData = await api.getTrackData({ vid: vin, startTime: sta, endTime: end })
        self.rightBar = {
          chargeMonthSt: chargeMonthSt.data.data,
          runKmMonthSt: runKmMonthSt.data.data
        }
        // this.detailsLoading = false
        let pathD = []
        trackData.data.data.forEach((d, i) => {
          // let { lat, lng } = self.GPS.gcj_encrypt(d[2503], d[2502])
          let lat = d[2503]
          let lng = d[2502]
          if (lat && lng) {
            pathD.push([lng, lat])
          }
        })
        self.path = pathD

        self.trackTimer = setInterval(self.trackDataPull, self.trackDuration)
        self.timer = setInterval(self.setRealTimeData, self.duration)
      }
      getStaticeData()
    },
    // 心率
    getHeartListData () {
      var self = this
      api.getHeartList({ vid: self.vin }).then(rs => {
        self.heartListData = rs.data.data
        if (self.HeardurationTimer) {
          return
        }
        self.HeardurationTimer = setInterval(() => {
          self.getHeartListData()
        }, self.Heardurationduration)
      })
    },
    async setRealTimeData () {
      const self = this
      const vehicleInfo = await api.getVehicleInfo({ vid: self.vin })
      self.vehicleInfo = vehicleInfo.data.data
    },
    // 报警
    setPoliceInfo () {
      var self = this
      api.getPoliceInfoList({ vid: self.vin }).then(rs => {
        self.policeInfoData = rs.data.data
        if (self.PoliceInfoTimer) {
          return
        }
        self.PoliceInfoTimer = setInterval(() => {
          self.setPoliceInfo()
        }, self.PoliceInfoduration)
      })
    },
    setguanmen () {
      var self = this
      api.getDoorData({ vid: self.vin }).then(rs => {
        self.doorData = rs.data.data
        if (self.durationTimer) {
          return
        }
        self.durationTimer = setInterval(() => {
          self.setguanmen()
        }, self.durationSixty)
      })
    },
    setTagStatusData () {
      var self = this
      api.getTagStatusData({ vid: self.vin }).then(rs => {
        if (rs.data.data == null) {
          self.tagStatusData = {
            'statusName': '-'
          }
        } else {
          self.tagStatusData = rs.data.data
        }
        if (self.tagStatusTimer) {
          return
        }
        self.tagStatusTimer = setInterval(() => {
          self.setTagStatusData()
        }, self.tagStatusduration)
      })
    },
    // 温湿度
    setHumidity () {
      var self = this
      api.getHumidityData({ vid: self.vin }).then(rs => {
        self.humidityData = rs.data.data
        if (self.durationmidityTimer) {
          return
        }
        self.durationmidityTimer = setInterval(() => {
          self.setHumidity()
        }, self.durationmiditySixty)
      })
    },

    setCar (data) {
      this.protocalType = data.powerMode === '传统燃油车' ? 6 : 5
      this.vin = data.vid
    },
    // 车速
    getvehRealTimeData (vin) {
      var self = this
      const vinIng = self.vinIng
      const vid = self.vin
      api.getVehRealTimeData({ vin: vinIng, vid: vid }).then(rs => {
        self.vehRealTimeData = rs.data.data
        if (self.vehRealTimeDataTimer) {
          return
        }
        self.vehRealTimeDataTimer = setInterval(() => {
          self.getvehRealTimeData()
        }, self.vehRealTimeDataduration)
      })
    },
    // 轮胎
    gettaiYaData () {
      var self = this
      self.taiYaData = {}
      if (self.taiYaDataTimer) {
        return
      }
      self.taiYaDataTimer = setInterval(() => {
        self.gettaiYaData()
      }, self.taiYaDataDuration)
    },
    // 报警
    getVehRealAlarm () {
      var self = this
      const vinIng = self.vinIng
      const vid = self.vin
      api.getVehRealAlarmData({ vin: vinIng, vid: vid }).then(rs => {
        self.vehehRealAlarmData = rs.data.data
        if (self.vehehRealAlarmTimer) {
          return
        }
        self.vehehRealAlarmTimer = setInterval(() => {
          self.getVehRealAlarm()
        }, self.vehehRealAlarmduration)
      })
    },
    async trackDataPull () {
      let sta = self.globalSta
      let end = self.globalEnd
      try {
        const trackData = await api.getTrackData({ vid: this.vin, startTime: sta, endTime: end })
        let pathD = []
        trackData.data.data.forEach((d, i) => {
          // let { lat, lng } = self.GPS.gcj_encrypt(d[2503], d[2502])
          let lat = d[2503]
          let lng = d[2502]
          if (lat && lng) {
            pathD.push([lng, lat])
          }
        })
        self.path = pathD
      } catch (error) {
        console.log(error)
      }
    },
    async getPathData (range) {
      var self = this
      if (this.isLoadingTrackData) {
        return
      }
      let st = new Date()
      let sta = dayjs(st)
      let end
      if (range > 0) {
        if (range === 30) {
          sta = sta.subtract(30, 'minute')
        } else {
          sta = sta.subtract(range, 'hour')
        }
        sta = sta.format('YYYY-MM-DD HH:mm:ss')
        end = dayjs(st).format('YYYY-MM-DD HH:mm:ss')
      } else {
        sta = dayjs(st).format('YYYY-MM-DD 00:00:00')
        end = dayjs(st).format('YYYY-MM-DD 23:59:59')
      }
      this.globalSta = sta
      this.globalEnd = end
      try {
        this.isLoadingTrackData = true
        const trackData = await api.getTrackData({ vid: this.vin, startTime: sta, endTime: end })
        let pathD = []
        trackData.data.data.forEach((d, i) => {
          // let { lat, lng } = self.GPS.gcj_encrypt(d[2503], d[2502])
          let lat = d[2503]
          let lng = d[2502]
          if (lat && lng) {
            pathD.push([lng, lat])
          }
        })
        this.path = pathD
        this.isLoadingTrackData = false
      } catch (error) {
        console.log(error)
        this.isLoadingTrackData = false
      }
    },
    // 清除所有定时
    clearIntervalAll () {
      this.timer && clearInterval(this.timer)
      this.timer = null
      this.trackTimer && clearInterval(this.trackTimer)
      this.trackTimer = null
      this.durationTimer && clearInterval(this.durationTimer)
      this.durationTimer = null
      this.taiYaDataTimer && clearInterval(this.taiYaDataTimer)
      this.taiYaDataTimer = null
      this.durationmidityTimer && clearInterval(this.durationmidityTimer)
      this.durationmidityTimer = null
      this.vehRealTimeDataTimer && clearInterval(this.vehRealTimeDataTimer)
      this.vehRealTimeDataTimer = null
      this.vehehRealAlarmTimer && clearInterval(this.vehehRealAlarmTimer)
      this.vehehRealAlarmTimer = null
      this.HeardurationTimer && clearInterval(this.HeardurationTimer)
      this.HeardurationTimer = null
      this.PoliceInfoTimer && clearInterval(this.PoliceInfoTimer)
      this.PoliceInfoTimer = null
      this.tagStatusTimer && clearInterval(this.tagStatusTimer)
      this.tagStatusTimer = null
    }
  },
  watch: {
    vin (val) {
      if (!val) return
      this.clearIntervalAll()
      this.setStaticData()
      this.setguanmen()
      this.setPoliceInfo()
      this.setHumidity()
      this.getvehRealTimeData()
      this.getVehRealAlarm()
      this.getHeartListData()
      this.gettaiYaData()
      this.setTagStatusData()
    }
  }
}
</script>

<style lang="scss" scoped>
.details-container {
  & > div {
    display: flex;
  }
}
</style>
